import { bind } from "@react-rxjs/core"
import { catchError, of, scan } from "rxjs"

import type {
  EquityOrder,
  EquityOrderUpdateResult,
} from "@/generated/TradingGateway"
import {
  ERROR_EQUITY_ORDER_UPDATE_RESULT,
  UpdateType,
} from "@/generated/TradingGateway"

import { EquityOrderService } from "../TradingGateway"

const orderHandlers: Partial<
  Record<
    UpdateType,
    (orders: EquityOrder[], order: EquityOrder) => EquityOrder[]
  >
> = {
  [UpdateType.StateOfTheWorld]: (orders, order) => [...orders, order],
  [UpdateType.Added]: (orders, order) => [...orders, order],
  [UpdateType.Updated]: (orders, order) =>
    orders.map((o) => (o.id === order.id ? order : o)),
  [UpdateType.Deleted]: (orders, order) =>
    orders.filter((o) => o.id !== order.id),
}

function orderReducer(
  orders: EquityOrder[],
  result: EquityOrderUpdateResult,
): EquityOrder[] {
  if (result.type === ERROR_EQUITY_ORDER_UPDATE_RESULT)
    throw new Error("Error received from EquityOrderService")
  const { updateType, order } = result.payload
  return orderHandlers[updateType]?.(orders, order) ?? orders
}

export const [useOrderHistory] = bind<EquityOrder[]>(
  EquityOrderService.getOrders().pipe(
    scan(orderReducer, []),
    catchError((err) => {
      console.error("Failed to load order history.", err)
      return of<EquityOrder[]>([])
    }),
  ),
  [],
)
